import { instantsInterceptor, } from '@/api/index';
import axios from "axios";
import { setInterceptors } from "@/api/common/interceptor";

function getDownloadChartData(year, firstDoctype, firstProdType, secondProdType) {
    return instantsInterceptor.get('/mgmt/statistics/docDownload/result?' + "year=" + year + "&firstDoctype=" + firstDoctype + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}

function getDocViewChartData(year, firstDoctype, firstProdType, secondProdType) {
    console.log(year);
    return instantsInterceptor.get('/mgmt/statistics/docView/result?' + "year=" + year + "&firstDoctype=" + firstDoctype + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}

function getWebHelpChartData(year, firstDoctype, firstProdType, secondProdType) {
    return instantsInterceptor.get('/mgmt/statistics/webHelp/result?' + "year=" + year + "&firstDoctype=" + firstDoctype + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}

function getFeedbackChartData(year, firstDoctype, firstProdType, secondProdType) {
    return instantsInterceptor.get('/mgmt/statistics/feedback/result?' + "year=" + year + "&firstDoctype=" + firstDoctype + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}

function getAccountCreateChartData(year, role) {
    return instantsInterceptor.get('/mgmt/statistics/accountCreate/result?' + "year=" + year + "&role=" + role);
}

function getDocRatioChartData(firstDoctype, firstProdType, secondProdType, page) {
    return instantsInterceptor.get('/mgmt/statistics/docRatio/result?' + "firstDoctype=" + firstDoctype + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType + "&page=" + page);
}

function userStatusStatisticsData(form) {
    return instantsInterceptor.post('/mgmt/statistics/userStatus/result', form);
}

function accountCreateStatisticsExcel(year, role) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/statistics/accountCreate/excel?' + "year=" + year + "&role=" + role);
}

function productStatisticsExcel(year, firstProdType, secondProdType) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/statistics/prodType/excel?' + "year=" + year + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}

function docTypeStatisticsExcel(year, firstDoctype) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/statistics/doctype/excel?' + "year=" + year + "&firstDoctype=" + firstDoctype);
}

function docDownloadStatisticsExcel(year, firstDoctype, firstProdType, secondProdType) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/statistics/docDownload/excel?year=' + year + "&firstDoctype=" + firstDoctype + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}

function docViewStatisticsExcel(year, firstDoctype, firstProdType, secondProdType) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/statistics/docView/excel?year=' + year + "&firstDoctype=" + firstDoctype + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}

function webHelpStatisticsExcel(year, firstDoctype, firstProdType, secondProdType) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/statistics/webHelp/excel?year=' + year + "&firstDoctype=" + firstDoctype + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}

function feedbackStatisticsExcel(year, firstDoctype, firstProdType, secondProdType) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/statistics/feedback/excel?' + "year=" + year + "&firstDoctype=" + firstDoctype + "&firstProdType=" + firstProdType + "&secondProdType=" + secondProdType);
}


function docRatioStatisticsExcel() {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.get('/mgmt/statistics/docRatio/excel');
}

function userStatusStatisticsExcel(form) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.post('/mgmt/statistics/userStatus/excel', form);
}

export {
    getDownloadChartData,
    getDocViewChartData,
    getWebHelpChartData,
    getFeedbackChartData,
    getAccountCreateChartData,
    getDocRatioChartData,
    accountCreateStatisticsExcel,
    productStatisticsExcel,
    docTypeStatisticsExcel,
    docDownloadStatisticsExcel,
    docViewStatisticsExcel,
    webHelpStatisticsExcel,
    feedbackStatisticsExcel,
    docRatioStatisticsExcel,
    userStatusStatisticsExcel,
    userStatusStatisticsData
};